"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addProperties = addProperties;
exports.addGetters = addGetters; // adds fluent style getter/setter methods to an object
// for the given list of properties

var getterSetter = function getterSetter(object, key) {
  return function (value) {
    if (arguments.length === 0) {
      return object[key];
    }

    object[key] = value;
    return object;
  };
};

var getter = function getter(object, key) {
  return function () {
    return object[key];
  };
};

function addProperties(object) {
  for (var _len = arguments.length, properties = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    properties[_key - 1] = arguments[_key];
  }

  for (var _i = 0, _properties = properties; _i < _properties.length; _i++) {
    var property = _properties[_i];
    object[property] = getterSetter(object, '_' + property);
  }
}

function addGetters(object) {
  for (var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    properties[_key2 - 1] = arguments[_key2];
  }

  for (var _i2 = 0, _properties2 = properties; _i2 < _properties2.length; _i2++) {
    var property = _properties2[_i2];
    object[property] = getter(object, '_' + property);
  }
}